"use strict";
exports.__esModule = true;
exports.TableSortLabel = exports.Table = exports.TableRow = exports.TableHead = exports.TableContainer = exports.TableCell = exports.TableBody = void 0;
var core_1 = require("@material-ui/core");
exports.Table = core_1.Table;
exports.TableBody = core_1.TableBody;
exports.TableCell = core_1.TableCell;
exports.TableContainer = core_1.TableContainer;
exports.TableHead = core_1.TableHead;
exports.TableRow = core_1.TableRow;
exports.TableSortLabel = core_1.TableSortLabel;
//# sourceMappingURL=Table.js.map